import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthPopinService } from '../auth-popin.service';
import { Subscription } from 'rxjs';
import { SigninFormLiteService } from '../components/signin-form-lite/signin-form-lite.service';
import { KzIconsRegistryService } from '../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsKozikaza } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-kozikaza.icon';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  saveSubscription: Subscription;
  submitted = false;

  constructor(
    private authPopinService: AuthPopinService,
    private signinFormLiteService: SigninFormLiteService,
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsKozikaza]);
  }

  ngOnInit() {
    this.saveSubscription = this.signinFormLiteService.submitted.subscribe(
      (value) => {
        if (value) {
          this.submitted = true;
        } else {
          this.submitted = false;
        }
      }
    );
  }

  save(): void {
    this.signinFormLiteService.submitted.next(true);
  }

  close(): void {
    this.authPopinService.close(true);
  }

  ngOnDestroy(): void {
    if (this.saveSubscription && !this.saveSubscription.closed) {
      this.saveSubscription.unsubscribe();
    }
  }
}
